import { Eye } from "lucide-react";
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import delicon from "../assets/delete.svg";
import update from "../assets/editBlack.svg";
import FilterIcon from "../assets/filterIcon.png";
import GreyArrow from "../assets/greyLeftAr.png";
import Search from "../assets/search.png";
import {
  computeplussevendays,
  computeTodayDate,
  handleEmailChange,
  handleError,
  handleIaphabetnumberChange,
  handleNumbersChange,
  goBack,
  handleSuccess,
  sortByCarTaglineAscending,
} from "../CommonJquery/CommonJquery.js";
import {
  APL_LINK,
  delete_website_master_data,
  get_all_car_data,
  server_post_data,
  newstatus_update_change,
} from "../ServiceConnection/serviceconnection.js";
import {
  GuestManagementPageText,
  options_search,
} from "./../CommonJquery/WebsiteText";
import "./Css/Viewtestimonial.css";
import Header from "./Header";

import { FaExclamationCircle, FaTimes } from "react-icons/fa";
import { Button } from "@mui/material";
import { ArrowLeft } from "lucide-react";
import Loader from "./Loader.js";
function ViewCardetails() {
  const navigate = useNavigate();
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const [showimage, setshowimage] = useState("");
  const [filterValue, setFilterValue] = useState("");
  const [showcardata, setshowcardata] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [carIdToToggle, setCarIdToToggle] = useState(null);
  const [newStatus, setNewStatus] = useState(false);
  const [Status, setStatus] = useState(false);
  const [carNameToToggle, setCarNameToToggle] = useState("");
  const [startDate, setStartDate] = useState(computeplussevendays());
  const [endDate, setEndDate] = useState(computeTodayDate());
  const [selectedValue, setSelectedValue] = useState("Name");
  const [filteredData, setfilteredData] = useState([]);
  const [searchfilter, setSearchFilter] = useState("");
  const [selectedId, setSelectedId] = useState(null);
  const [showDltModal, setshowDltModal] = useState(false);
  const [showIpassDltModal, setshowIpassDltModal] = useState(false);
  const [assignModalOpen, setAssignModalOpen] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [statusNotes, setStatusNotes] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const search_data = () => {
    const flag = "2";
    const call_id = "0";
    master_data_get(startDate, endDate, flag, call_id);
  };

  const openStatusModal = (carId) => {
    setAssignModalOpen(true);
    setCarIdToToggle(carId);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = sortByCarTaglineAscending(filteredData)
    ? filteredData.slice(indexOfFirstItem, indexOfLastItem)
    : [];
  const totalPages = filteredData
    ? Math.ceil(filteredData.length / itemsPerPage)
    : 0;

  // 3. Add this function for handling page changes
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // 4. Add this function to render pagination buttons
  const renderPaginationButtons = () => {
    const buttons = [];

    // Previous button
    buttons.push(
      <li className="cust_hist_page_item" key="prev">
        <button
          className="cust_hist_page_link cust_hist_page_prev"
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          <span className="sr-only">Previous</span>
          <svg
            className="cust_hist_page_icon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fillRule="evenodd"
              d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      </li>,
    );

    // Page buttons
    // Show max 5 page buttons with current page in the middle when possible
    let startPage = Math.max(1, currentPage - 2);
    let endPage = Math.min(totalPages, startPage + 4);

    // Adjust startPage if endPage is at maximum
    if (endPage === totalPages) {
      startPage = Math.max(1, endPage - 4);
    }

    for (let i = startPage; i <= endPage; i++) {
      buttons.push(
        <li className="cust_hist_page_item" key={i}>
          <button
            className={`cust_hist_page_link ${
              currentPage === i ? "cust_hist_page_active" : ""
            }`}
            onClick={() => handlePageChange(i)}
          >
            {i}
          </button>
        </li>,
      );
    }

    // Next button
    buttons.push(
      <li className="cust_hist_page_item" key="next">
        <button
          className="cust_hist_page_link cust_hist_page_next"
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages || totalPages === 0}
        >
          <span className="sr-only">Next</span>
          <svg
            className="cust_hist_page_icon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fillRule="evenodd"
              d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      </li>,
    );

    return buttons;
  };

  useEffect(() => {
    const flag = "1";
    let call_id = "0";
    master_data_get("", "", flag, call_id);
  }, []);

  const master_data_get = async (startDate, endDate, flag, call_id) => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("flag", flag);
    fd.append("start_date", startDate);
    fd.append("end_date", endDate);
    fd.append("call_id", call_id);
    fd.append("search_option", selectedValue);
    fd.append("search_data", document.getElementById("search_data").value);
    await server_post_data(get_all_car_data, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          setshowcardata(Response.data.message.data_subscribe);
          console.log(Response.data.message.data_subscribe);
          setfilteredData(Response.data.message.data_subscribe);
          setshowcardata(Response.data.message.data_subscribe);
          setshowimage(Response.data.message.image_link);
          // if (Response.data.message.data.length > 0) {
          //   setshowcardetails(Response.data.message.multiimage[0]);
          //   setshowcarimage(Response.data.message.car_image);
          // }
        }

        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        // handleError("network");
        setshowLoaderAdmin(false);
      });
  };
  const handleSearch = (event) => {
    const searchValue = event.target.value;
    setSearchFilter(searchValue);

    const filteredDatashow = showcardata.filter((row) => {
      return Object.values(row).some((value) => {
        if (value !== null && value !== undefined) {
          return (
            typeof value === "string"
              ? value.toLowerCase()
              : value.toString().toLowerCase()
          ).includes(searchValue.toLowerCase());
        }
        return false;
      });
    });

    setfilteredData(filteredDatashow);
  };
  const handleEdit = (id) => {
    navigate(`/EditCarDetailNew/${id}`);
  };

  const handleNavigate = () => {
    navigate("/AddCarDetailNew");
  };
  const handleNavigate1 = (id) => {
    navigate(`/View_carfaq/${id}`);
  };

  const handleStatusToggle = (carId, carName, status, currentStatus) => {
    setStatus(status);
    setCarIdToToggle(carId);
    setCarNameToToggle(carName);
    setNewStatus(status == 1 ? false : true);
    setShowModal(true);
  };

  // Toggle New Status Funtion
  const toggleNewStatus = async () => {
    if (selectedStatus != "") {
      let fd_from = new FormData();
      fd_from.append("car_status", selectedStatus);
      fd_from.append("car_status_notes", statusNotes);
      fd_from.append("call_id", carIdToToggle);
      await server_post_data(newstatus_update_change, fd_from)
        .then((Response) => {
          setshowLoaderAdmin(false);
          if (Response.data.error) {
            handleError(Response.data.message);
          } else {
            setAssignModalOpen(false);
            master_data_get("", "", 1, 0);
            handleSuccess(Response.data.message);
          }
        })
        .catch((error) => {
          console.log(error);
          setshowLoaderAdmin(false);
        });
    } else {
      alert("Please select a status");
    }

    setShowModal(false);
  };

  const handleDelete = async (primaryId) => {
    let fd_from = new FormData();
    fd_from.append("id_for_delete", primaryId);
    fd_from.append("flag_for", 7);
    fd_from.append("for_status_final", "d");
    await server_post_data(delete_website_master_data, fd_from)
      .then((Response) => {
        setshowLoaderAdmin(false);
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          master_data_get("", "", 1, 0);
        }
      })
      .catch((error) => {
        console.log(error);
        setshowLoaderAdmin(false);
      });
  };
  const handleDltCloseModal = () => {
    setshowDltModal(false);
  };
  const handleShowDltModl = (primaryId, car) => {
    if (parseInt(car.ipass_id) == 0) {
      setSelectedId(primaryId);
      setshowDltModal(true);
    } else {
      setshowIpassDltModal(true);
    }
    console.log("car details", car);
  };

  const handleDeleteYes = () => {
    if (selectedId) {
      handleDelete(selectedId);
    }
    setshowDltModal(false);
  };
  const handleIpassDeleteYes = () => {
    navigate("/Manage-Ipass");
  };

  const handleNavigateBack = (id) => {
    navigate(`/view_car_detail/${id}`);
  };

  const capitalizeWords = (str) => {
    return str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
  };

  const downloadCarDetailsCSV = (data) => {
    const headers = [
      "Car Tagline",
      "Car Number",
      "Make Year",
      "Car Name",
      "VIN",
      "Status",
      "Status Note",
      "Insurance Company",
      "Registration Company",
    ];

    const rows = showcardata.map((item) => {
      const car = item;
      return [
        car.car_tagline || "",
        car.car_name || "",
        car.car_no || "",
        car.make_year || "",
        car.vin || "",
        car.booking_status || "", // Status
        "", // Status Note
        "", // Insurance Company
        car.registration_company || "",
      ];
    });

    const csvContent =
      "data:text/csv;charset=utf-8," +
      [headers, ...rows]
        .map((row) =>
          row
            .map((field) => `"${String(field).replace(/"/g, '""')}"`)
            .join(","),
        )
        .join("\n");

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "car_details.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const statusData = [
    { value: "Available", label: "Available" },
    { value: "Booked", label: "Booked" },
    { value: "Taxi", label: "Taxi" },
    { value: "Repair", label: "Repair" },
    { value: "Bodywork", label: "Bodywork" },
    { value: "Insurance", label: "Insurance" },
    { value: "Test", label: "Test" },
    { value: "New", label: "New" },
    { value: "Assigned", label: "Assigned" },
    { value: "Sale", label: "Sale" },
    { value: "Standby", label: "Standby" },
    { value: "Deactive", label: "Deactive" },
  ];

  // Place this useEffect after your existing useEffects
  useEffect(() => {
    if (filterValue && filterValue !== "") {
      const filtered = showcardata.filter((car) => {
        // Trim and compare car_status with selected filter
        return (
          car.car_status &&
          car.car_status.trim().toLowerCase() === filterValue.toLowerCase()
        );
      });
      setfilteredData(filtered);
      setCurrentPage(1); // Reset to first page when filter changes
    } else {
      // If no filter selected, show all cars
      setfilteredData(showcardata);
    }
  }, [filterValue, showcardata]);

  return (
    <div className="dashboard">
      {showLoaderAdmin && <Loader />}
      <Header />
      <div className="container-lg"></div>
      <div className="dashboard_container">
        <div className="page_content">
          <div className="page_content_container">
            <div className="pageCntn_head">
              <div className="pageNameDiv">
                <div className="d-flex gap-2 align-items-center">
                  <p className="breadcrumb-item">View Owned Cars</p>
                  <img
                    src={GreyArrow}
                    alt="Rapid Car Leasing"
                    style={{ height: "14px" }}
                  />
                </div>
              </div>
              <div className={` alignCol bottomAlgin col-xl-3 mb-0`}>
                <div className="pageActionBtns">
                  <button
                    onClick={downloadCarDetailsCSV}
                    className="CSVBTN"
                    style={{ height: "38px" }}
                  >
                    Download Excel
                  </button>
                </div>
              </div>
              <Button
                onClick={goBack}
                startIcon={
                  <ArrowLeft size={17} style={{ marginBottom: "2px" }} />
                }
                className="Back_bttn_page"
              >
                Back
              </Button>
            </div>

            <div className="page_body">
              <div className="viewStaff">
                <div className="viewStaff_head">
                  <div className="row m-0">
                    <div
                      className="d-none"
                      style={{ opacity: "0", pointerEvents: "none" }}
                    >
                      <div className="inputDiv2">
                        <img src={Search} alt="Rapid Car Leasing" />
                        <input
                          type="text"
                          id="search_data"
                          onInput={(e) => {
                            if (selectedValue === options_search[0].value) {
                              // handleAphabetsChange(e);
                            } else if (
                              selectedValue === options_search[1].value
                            ) {
                              handleEmailChange(e);
                            } else if (
                              selectedValue === options_search[2].value
                            ) {
                              handleNumbersChange(e);
                            }
                          }}
                          placeholder={GuestManagementPageText.Search_Guest}
                        />
                        <button
                          type="button"
                          className="btnSearch"
                          onClick={() => search_data()}
                        >
                          Search
                        </button>
                      </div>
                    </div>
                    <div className="d-flex justify-content-between">
                      <div className="col-lg-3 col-sm-4 bottomAlgin">
                        <div className="inputDiv2">
                          <label style={{ whiteSpace: "nowrap" }}>
                            <img src={FilterIcon} alt="Rapid Car Leasing" />
                            {/* Sort By:{" "} */}
                          </label>
                          <select
                            onChange={(e) => {
                              setFilterValue(e.target.value);
                            }}
                          >
                            <option value="">Filter By</option>
                            {statusData &&
                              statusData.map((option, index) => (
                                <option value={option.value}>
                                  {option.label}
                                </option>
                              ))}
                          </select>
                        </div>
                      </div>
                      <div className="addTestno d-flex justify-content-end gap-2">
                        <button type="button" onClick={handleNavigate}>
                          Add Car
                        </button>
                        <div style={{ marginRight: "0" }}>
                          <div className="inputDiv2">
                            <label
                              className="labelPointer"
                              htmlFor="selectFilter"
                            >
                              <img src={FilterIcon} alt="Rapid Car Leasing" />
                            </label>
                            <input
                              type="text"
                              placeholder={GuestManagementPageText.Guest_Filter}
                              value={searchfilter}
                              onInput={handleIaphabetnumberChange}
                              onChange={handleSearch}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div style={{ padding: "0 10px" }}>
                  <div className="cust_hist_card" style={{ padding: "0 10px" }}>
                    <div className="reservationHistoryTable">
                      <div
                        className="historyTableContainer stickyTableheigh274"
                        style={{ overflowX: "auto" }}
                      >
                        <table className="table margin_class_table">
                          <thead className="stickyHeaderClss">
                            <tr>
                              <th scope="col">Sr.No.</th>
                              <th scope="col">Car Name</th>
                              <th scope="col">Assigned Ipass</th>
                              <th scope="col">Price</th>
                              <th scope="col">Color & Year</th>
                              <th scope="col">Car Image</th>
                              <th scope="col">Status</th>
                              <th scope="col">Type</th>
                              <th scope="col">Action</th>
                            </tr>
                          </thead>
                          <tbody className="custum_border">
                            {currentItems && currentItems.length > 0 ? (
                              currentItems.map((car, index) => (
                                <tr
                                  className="historyTableRow h-auto"
                                  key={index}
                                >
                                  <td>
                                    <div
                                      className="historyTableRowText justify-content-start height50 historyName"
                                      style={{
                                        marginLeft: "20px",
                                      }}
                                    >
                                      {indexOfFirstItem + index + 1}
                                    </div>
                                  </td>
                                  <td>
                                    <div className="historyTableRowText justify-content-start height50 historyName">
                                      <strong>
                                        {car.car_tagline} - <span style={{fontWeight:'500'}}>{car.car_no}</span>
                                      </strong>{" "}
                                      {car.car_name}
                                    </div>
                                  </td>
                                  <td>
                                    <div className="historyTableRowText justify-content-start height50 historyName">
                                      {car.ipass_number == "null" ||
                                      car.ipass_number == " " ? (
                                        "-"
                                      ) : (
                                        <strong>{car.ipass_number}</strong>
                                      )}
                                    </div>
                                  </td>
                                  <td>
                                    <div className="historyTableRowText justify-content-start height50 historyName">
                                      ${car.Price}
                                    </div>
                                  </td>
                                  <td>
                                    <div className="historyTableRowText justify-content-start height50 historyName">
                                      {car.color}, {car.make_year}
                                    </div>
                                  </td>
                                  <td>
                                    {/* <div className="historyTableRowText height50 historyName">
                                     
                                    </div> */}
                                    <div
                                      className="guest_incenter borderLeftRadius"
                                      style={{ width: "40%" }}
                                    >
                                      <img
                                        src={
                                          APL_LINK + showimage + car.image ||
                                          "default-image.png"
                                        }
                                        alt={car.car_name}
                                        style={{
                                          objectFit: "cover",
                                          height: "55px",
                                          width: "55px",
                                          borderRadius: "50%",
                                          marginTop: "0.8rem",
                                        }}
                                      />
                                    </div>
                                  </td>
                                  <td>
                                    {car.active_status === 0 ? (
                                      <div
                                        className={`guest_incenter borderLeftRadius status-free`}
                                        style={{
                                          height: "30px",
                                          fontSize: "13px",
                                          whiteSpace: "nowrap",
                                          border: "1px solid",
                                          width: "110px",
                                          borderRadius: "20px",
                                          padding: "0rem 0.7rem",
                                        }}
                                      >
                                        In-active
                                      </div>
                                    ) : (
                                      <div
                                        className={`guest_incenter borderLeftRadius ${
                                          car.car_status == "Available"
                                            ? "status-booked"
                                            : car.car_status == "OUT OF SERVICE"
                                              ? "status-free"
                                              : car.car_status == "RENTED "
                                                ? "status-upcoming"
                                                : ""
                                        }`}
                                        style={{
                                          height: "30px",
                                          fontSize: "13px",
                                          whiteSpace: "nowrap",
                                          border: "1px solid",
                                          width: "110px",
                                          borderRadius: "20px",
                                          padding: "0rem 0.7rem",
                                        }}
                                      >
                                        {capitalizeWords(car.car_status)}
                                      </div>
                                    )}
                                  </td>
                                  <td>
                                    <div
                                      className="historyTableRowText justify-content-start height50 historyPerson "
                                      style={{ flexWrap: "wrap" }}
                                    >
                                      {car.model_name}
                                    </div>
                                  </td>
                                  <td>
                                    <div
                                      className="actioniconstest"
                                      style={{ gap: "1rem", width: "60%" }}
                                    >
                                      <button
                                        className="eye_bttn"
                                        type="button"
                                        onClick={() =>
                                          handleNavigateBack(car.primary_id)
                                        }
                                        title="View Car Details"
                                      >
                                        <Eye size={20} strokeWidth={1.5} />
                                      </button>
                                      {/* <div
                                        onClick={() =>
                                          openStatusModal(car.primary_id)
                                        }
                                        style={{ cursor: "pointer" }}
                                        className="StatusTogglebttn"
                                      >
                                        <img
                                          src={
                                            car.active_status === 0
                                              ? powerSwitch
                                              : powerSwitchRed
                                          }
                                          alt={
                                            car.active_status === 0
                                              ? "Inactive"
                                              : "Active"
                                          }
                                        />
                                      </div> */}
                                      <img
                                        className="del-icon"
                                        src={update}
                                        onClick={() =>
                                          handleEdit(car.primary_id)
                                        }
                                        alt="Edit"
                                        style={{ cursor: "pointer" }}
                                        title="Edit this car"
                                      />
                                      <img
                                        className="del-icon"
                                        src={delicon}
                                        alt="Delete"
                                        title="Delete this car"
                                        style={{ cursor: "pointer" }}
                                        onClick={() =>
                                          handleShowDltModl(car.primary_id, car)
                                        }
                                      />
                                      <div className="">
                                        <button
                                          className="tbnWhiteNew"
                                          type="button"
                                          style={{ whiteSpace: "nowrap" }}
                                          onClick={() =>
                                            openStatusModal(car.primary_id)
                                          }
                                        >
                                          Update Status
                                        </button>
                                      </div>
                                      <div className="">
                                        <button
                                          className="tbnWhiteNew"
                                          type="button"
                                          onClick={() =>
                                            handleNavigate1(car.primary_id)
                                          }
                                        >
                                          Faq
                                        </button>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={6} className="text_align_center">
                                  No Results Found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>

                        <div className="cust_hist_card_footer">
                          <div className="cust_hist_pagination_info">
                            {filteredData && filteredData.length > 0 ? (
                              <>
                                Showing{" "}
                                <span className="cust_hist_pagination_bold">
                                  {indexOfFirstItem + 1}
                                </span>{" "}
                                to{" "}
                                <span className="cust_hist_pagination_bold">
                                  {Math.min(
                                    indexOfLastItem,
                                    filteredData.length,
                                  )}
                                </span>{" "}
                                of{" "}
                                <span className="cust_hist_pagination_bold">
                                  {filteredData.length}
                                </span>{" "}
                                cars
                              </>
                            ) : (
                              <>
                                Showing{" "}
                                <span className="cust_hist_pagination_bold">
                                  0
                                </span>{" "}
                                cars
                              </>
                            )}
                          </div>
                          <div className="cust_hist_pagination">
                            <nav aria-label="Pagination">
                              <ul className="cust_hist_pagination_list">
                                {renderPaginationButtons()}
                              </ul>
                            </nav>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <Modal
        className="statusModal"
        backdrop="static"
        centered
        size="md"
        show={showModal}
        onHide={cancelToggleStatus}
      >
        <Modal.Body>
          <div className="statusContntDiv">
            {" "}
            <div className="d-flex flex-column align-items-center gap-3">
              <img src={UserIconOrenge} alt="UserIconOrenge"></img>
              {//console.log("newStatus", newStatus)}
              <p>
                Are you sure you want to {newStatus ? "activate" : "deactivate"}{" "}
                this car: <strong>{carNameToToggle}</strong>?
              </p>
              <div className="StatusDecideBttn">
                <button className="yesBtnStasus" onClick={confirmToggleStatus}>
                  Yes
                </button>
                <button className="noBtnStsus" onClick={cancelToggleStatus}>
                  No
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal> */}
      {/**-----------delete car---------------- */}
      <Modal
        className="testMsgModal"
        show={showDltModal}
        onHide={handleDltCloseModal}
        size="md"
        centered
      >
        <Modal.Body>
          <div className="closeBtn" onClick={handleDltCloseModal}>
            <FaTimes className="closeIcn" />
          </div>
          {/* Icon Section */}
          <div className="text-center my-3">
            <FaExclamationCircle
              className="confirmationIcon"
              size={45}
              color="#f44336"
            />
          </div>
          <div className="confirmAtionDltmsG">
            <p>Are You Sure want to delete</p>
          </div>
          <div className="dltBtttn">
            <button type="button" onClick={handleDeleteYes}>
              Yes
            </button>
            <button
              type="button"
              className="noBttn"
              onClick={handleDltCloseModal}
            >
              No
            </button>
          </div>
        </Modal.Body>
      </Modal>

      {/* Unassing Ipass first Modal */}
      <Modal
        className="testMsgModal"
        show={showIpassDltModal}
        onHide={handleDltCloseModal}
        size="md"
        centered
      >
        <Modal.Body>
          <div className="closeBtn" onClick={() => setshowIpassDltModal(false)}>
            <FaTimes className="closeIcn" />
          </div>
          {/* Icon Section */}
          <div className="text-center my-3">
            <FaExclamationCircle
              className="confirmationIcon"
              size={45}
              color="#f44336"
            />
          </div>
          <div className="confirmAtionDltmsG">
            <p className="py-3 px-5 text-center">
              This car is currently assigned an iPass. Please unassign the iPass
              from the iPass Management section before deleting the car.
            </p>
          </div>
          <div className="dltBtttn">
            <button type="button" onClick={handleIpassDeleteYes}>
              Manage Ipass
            </button>
            <button
              type="button"
              className="noBttn"
              onClick={() => setshowIpassDltModal(false)}
            >
              Cancel
            </button>
          </div>
        </Modal.Body>
      </Modal>

      {/* Car Status Update Pop-Up */}
      <Modal
        show={assignModalOpen}
        onHide={() => setAssignModalOpen(false)}
        className="ipass-modal"
        centered
      >
        <Modal.Header
          style={{ backgroundColor: "var(--primary-color)" }}
          closeButton
        >
          <Modal.Title style={{ color: "#fff" }}>
            Change Vehicle Status
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <p className="text-muted">
            Assign I-Pass{" "}
            <span className="fw-medium">{selectedIPass.ipass_id}</span> to a
            vehicle.
          </p> */}
          <form id="assignForm">
            <div className="mb-3">
              <label
                htmlFor="selectVehicle"
                className="form-label ipass-form-label"
              >
                Select Status
              </label>
              <select
                id="selectVehicle"
                name="vehicleId"
                className="form-select"
                required
                onChange={(e) => setSelectedStatus(e.target.value)}
              >
                <option value="" disabled selected>
                  -- Select a Status --
                </option>
                {statusData &&
                  statusData.length > 0 &&
                  statusData.map((vehicle, idx) => (
                    <option key={vehicle.value}>{vehicle.label}</option>
                  ))}
              </select>
              {/* {carDataSelectedError && (
                <div className="text-danger">{carDataSelectedError}</div>
              )} */}
            </div>
            <div className="mb-3">
              <label
                htmlFor="assignmentNotes"
                className="form-label ipass-form-label"
              >
                Notes (Optional)
              </label>
              <textarea
                id="assignmentNotes"
                name="notes"
                rows="3"
                className="form-control"
                placeholder="Add any additional information about this assignment"
                onChange={(e) => setStatusNotes(e.target.value)}
              ></textarea>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setAssignModalOpen(false)}>
            Cancel
          </Button>
          <Button
            style={{
              backgroundColor: "var(--primary-color)",
              border: "none",
              color: "#ffffff",
            }}
            onClick={toggleNewStatus}
          >
            Update
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default ViewCardetails;
